import ScrollBarHelper from "../../shared/scrollbar";
const defaultBreakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
};
export default class MetaInfo {
    // #region Vars
    _ScrollbarHelper = {};
    _MetaCache = {};
    title = '';
    mobileNavVisible = false;
    options = {};
    width = 0;
    height = 0;
    mediaSize = 'xs';
    // #endregion
    // #region Constructor
    init() {
        //Init
        this.handleResize();
        //Vars
        this._ScrollbarHelper = new ScrollBarHelper();
        //Events
        window.addEventListener('resize', (e) => this.handleResize(), false);
    }
    // #endregion
    // #region Scrollbar
    scrollbarShow() {
        this._ScrollbarHelper?.reset();
    }
    scrollbarHide() {
        this._ScrollbarHelper?.hide();
    }
    // #endregion
    // #region Sizing
    isMediaSizeDown(size) {
        if (size == 'xxl') {
            return this.mediaSize === 'xl' || this.mediaSize === 'lg' || this.mediaSize === 'md' || this.mediaSize === 'sm' || this.mediaSize === 'xs';
        }
        else if (size == 'xl') {
            return this.mediaSize === 'lg' || this.mediaSize === 'md' || this.mediaSize === 'sm' || this.mediaSize === 'xs';
        }
        else if (size == 'lg') {
            return this.mediaSize === 'md' || this.mediaSize === 'sm' || this.mediaSize === 'xs';
        }
        else if (size == 'md') {
            return this.mediaSize === 'sm' || this.mediaSize === 'xs';
        }
        else if (size == 'sm') {
            return this.mediaSize === 'xs';
        }
        else {
            return false;
        }
    }
    handleResize() {
        //Size
        appHost.pageMeta.width = window.innerWidth;
        appHost.pageMeta.height = window.innerHeight;
        //Media
        if (this.width >= defaultBreakpoints.xxl) {
            this.mediaSize = 'xxl';
        }
        else if (this.width >= defaultBreakpoints.xl) {
            this.mediaSize = 'xl';
        }
        else if (this.width >= defaultBreakpoints.lg) {
            this.mediaSize = 'lg';
        }
        else if (this.width >= defaultBreakpoints.md) {
            this.mediaSize = 'md';
        }
        else if (this.width >= defaultBreakpoints.sm) {
            this.mediaSize = 'sm';
        }
        else {
            this.mediaSize = 'xs';
        }
    }
    // #endregion
    // #region Scripts
    loadScript(src) {
        return new Promise(function (resolve, reject) {
            let shouldAppend = false;
            let el = document.querySelector('script[src="' + src + '"]');
            if (!el) {
                el = document.createElement('script');
                el.type = 'text/javascript';
                el.async = true;
                el.src = src;
                shouldAppend = true;
            }
            else if (el.hasAttribute('data-loaded')) {
                return resolve(el);
            }
            el.addEventListener('error', reject);
            el.addEventListener('abort', reject);
            el.addEventListener('load', function loadScriptHandler() {
                el.setAttribute('data-loaded', 'true');
                resolve(el);
            });
            if (shouldAppend) {
                document.head.appendChild(el);
            }
        });
    }
    unloadScript(src) {
        return new Promise(function (resolve, reject) {
            const el = document.querySelector('script[src="' + src + '"]');
            if (!el) {
                reject();
                return;
            }
            document.head.removeChild(el);
            resolve();
        });
    }
    loadStyle(src) {
        return new Promise(function (resolve, reject) {
            let shouldAppend = false;
            let el = document.querySelector('link[href="' + src + '"][rel="stylesheet"]');
            if (!el) {
                el = document.createElement('link');
                el.rel = 'stylesheet';
                el.href = src;
                shouldAppend = true;
            }
            else if (el.hasAttribute('data-loaded')) {
                return resolve(el);
            }
            el.addEventListener('error', reject);
            el.addEventListener('abort', reject);
            el.addEventListener('load', function loadScriptHandler() {
                el.setAttribute('data-loaded', 'true');
                resolve(el);
            });
            if (shouldAppend) {
                document.head.appendChild(el);
            }
        });
    }
    unloadStyle(src) {
        return new Promise(function (resolve, reject) {
            const el = document.querySelector('link[href="' + src + '"][rel="stylesheet"]');
            if (!el) {
                reject();
                return;
            }
            document.head.removeChild(el);
            resolve();
        });
    }
    // #endregion
    // #region Meta
    setMeta(data) {
        if (data?.title) {
            this.title = data.title;
        }
        if (data?.meta) {
            data.meta.forEach(e => {
                if (!e.content) {
                    return;
                }
                this.writeMetaTag(e.name, e.content);
            });
        }
    }
    resetMeta() {
        document.querySelectorAll('meta[v-meta-id="m"]').forEach(e => {
            let tNode = e;
            if (this._MetaCache[tNode.name]) {
                tNode.content = this._MetaCache[tNode.name];
                tNode.removeAttribute('v-meta-id');
            }
            else {
                document.head.removeChild(tNode);
            }
        });
    }
    // #endregion
    // #region Mobile
    toogleMobileNav() {
        this.mobileNavVisible = !this.mobileNavVisible;
    }
    showMobileNav() {
        this.mobileNavVisible = true;
    }
    hideMobileNav() {
        this.mobileNavVisible = false;
    }
    // #endregion
    // #region Helper
    writeMetaTag(name, content) {
        //Find
        let tIsNew = false;
        let tElement = document.querySelector('meta[name="' + name + '"]');
        //New
        if (!tElement) {
            tElement = document.createElement('meta');
            tElement.name = name;
            tIsNew = true;
        }
        else {
            if (!tElement.getAttribute("v-meta-id")) {
                this._MetaCache[name] = tElement.content;
            }
        }
        //Set
        tElement.content = content;
        tElement.setAttribute("v-meta-id", "m");
        //Add
        if (tIsNew) {
            document.head.appendChild(tElement);
        }
    }
}
